import axios from 'axios'
import store from '@/store'

export default {
  getAvailableContractorTelegrams () {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/notifications/telegram/contractors/available`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('telegram/setAvailableContractorTelegrams', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getContractorTelegrams (params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/notifications/telegram/contractors${params}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('telegram/setContractorTelegrams', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  editContractorTelegram (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/notifications/telegram/contractors/${params.contractor_id}`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  removeContractorTelegram (id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/notifications/telegram/contractors/${id}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getContractorTelegramCampaigns (params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/notifications/telegram/contractor-campaigns${params}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('telegram/setContractorTelegramCampaigns', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  createContractorTelegramCampaign (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/notifications/telegram/contractor-campaigns`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  editContractorTelegramCampaign (params) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/notifications/telegram/contractor-campaigns/${params.id}`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  startContractorTelegramCampaign (id) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/notifications/telegram/contractor-campaigns/${id}/start`, {}, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  removeContractorTelegramCampaign (id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/notifications/telegram/contractor-campaigns/${id}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },

  getAvailablePartnerTelegrams () {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/notifications/telegram/partners/available`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('telegram/setAvailablePartnerTelegrams', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getPartnerTelegrams (params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/notifications/telegram/partners${params}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('telegram/setPartnerTelegrams', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  editPartnerTelegram (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/notifications/telegram/partners/${params.partner_id}`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  removePartnerTelegram (id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/notifications/telegram/partners/${id}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  getPartnerTelegramCampaigns (params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/notifications/telegram/partner-campaigns${params}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('telegram/setPartnerTelegramCampaigns', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  createPartnerTelegramCampaign (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/notifications/telegram/partner-campaigns`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  editPartnerTelegramCampaign (params) {
    return new Promise((resolve, reject) => {
      axios
        .patch(`/api/notifications/telegram/partner-campaigns/${params.id}`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  startPartnerTelegramCampaign (id) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/notifications/telegram/partner-campaigns/${id}/start`, {}, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  removePartnerTelegramCampaign (id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/notifications/telegram/partner-campaigns/${id}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  }
}
